<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>
                    <div class="container-right">
                        <div class="page-title cabinet-page-title visibility">
                            Промокод
                        </div>
                        <div class="admin-promocode">
                            <div class="promocode-gen-wrapper" v-show="!!promocode">
                                <div class="promocode-gen">{{ promocode }}</div>
                            </div>
                            <button class="button blue-button"
                                    :disabled="queryIsPerforming"
                                    @click="sendGeneratePromocodeRequest">Сгенерировать промокод
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';

    export default {
        name: "AdminPromocode",

        components: {
            Header, Footer, UserMenu
        },

        data() {
            return {
                promocode: null
            }
        },

        computed: {
            queryIsPerforming() {
                return this.$store.getters.restQueryIsPerforming;
            }
        },

        methods: {
            async sendGeneratePromocodeRequest() {
                if (!!this.queryIsPerforming)
                    return;

                this.promocode = null;

                let promocode = await this.$store.dispatch('generatePromocode');
                if (!!promocode)
                    this.promocode = promocode.code;
            }
        }
    }
</script>